import { VehicleList } from "./VehicleList";

export function MotorcyclesList() {
  return <VehicleList resource="motorcycles" />;
}
